import React, { useCallback, useEffect, useRef, useState } from "react";
import { columns, searchBy } from "../../../service/AUCategoryService";
import { toast } from "react-toastify";
import BasicTable from "../../../components/Table/BasicTable";
import MenuApi from "../../../apis/menu.apis";
import { ApproveUnapproveApi } from "../../../apis/a&uApi";

const AUCategoryComponent = ({ pagination, handlePagination }) => {
  const [search, setSearch] = useState("");
  const debounceTimeout = useRef(null);

  const [selectedOrder] = useState(null);
  const [categoryData, setPromocodeData] = useState(null);

  const getAllCategory = async () => {
    try {
      const res = await MenuApi.getVenderCategory(pagination, search);
      setPromocodeData(res?.data?.data);
    } catch (error) {
      toast.error(error?.message);
    }
  };

  const handleCellClick = async (row, action) => {
    if (action === "Approved" || action === "Unapproved") {
      try {
        await ApproveUnapproveApi.updateCategoryApprovalStatus(row?._id, {
          status: action,
        });
        getAllCategory();
      } catch (error) {
        toast.error(error?.message);
      }
    }
  };

  const onPaginatorClick = (e) => {
    if (e) {
      const data = {
        limit: e.rows,
        page: +e.page + 1,
      };
      handlePagination && handlePagination(data);
    }
  };

  const handleSearch = useCallback((s) => {
    setSearch(s);
  }, []);

  const debouncedSearch = useCallback(
    (s) => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
      debounceTimeout.current = setTimeout(() => {
        handleSearch(s);
      }, 1500);
    },
    [handleSearch]
  );

  const handleClearFilter = () => {
    const clearPagination = {
      page: 1,
      limit: 5,
      sortOrder: "desc",
      filter: {},
    };
    handlePagination && handlePagination({ clearPagination });
  };
  const handleFilter = (name, value) => {
    let data = {};
    if (name === "search_by") {
      data.sortOrder = value.code;
    } else {
      const filter = {};
      filter[name] = value.code ? value.code : value;
      data.filter = filter;
    }

    handlePagination && handlePagination(data);
  };

  useEffect(() => {
    getAllCategory();
  }, [pagination, search]);

  return (
    <div className="">
      <BasicTable
        columns={columns}
        data={categoryData?.categories}
        onPaginatorClick={onPaginatorClick}
        paginatorData={{
          filters: null,
          first: 0,
          multiSortMeta: [],
          page: categoryData?.limit || 5,
          sortField: null,
          sortOrder: null,
          totalPages: categoryData?.totalPages || 1,
          totalCount: categoryData?.totalCount || 1,
        }}
        SearchBy={searchBy}
        handleSearch={debouncedSearch}
        handleFilter={(name, value) => handleFilter(name, value)}
        handleClearFilter={handleClearFilter}
        // filters={filters}
        selectedData={selectedOrder}
        handleCellClick={handleCellClick}
      />
    </div>
  );
};

export default AUCategoryComponent;
